export type Props = {
  value: string;
  valueLength: number;
  autoFocus?: boolean;
  onChange: (value: string) => void;
};
export default function OtpInput(props: any) {
  return (
    <div className="otp-group">
      {[1, 2, 3, 4].map((digit, index) => (
        <input
          key={index}
          type="text"
          autoComplete="one-time-code"
          className="otp-input fs-22 fw-600 h-60px w-60px me-8"
          value={props.value[index] || ''}
          style={{ border: 'solid 0.5px #e0e0df' }}
          onChange={(e) => {
            const newValue = [...props.value];
            newValue[index] = e.target.value;
            props.onChange(newValue);
          }}
          maxLength={1}
          autoFocus={index === 0}
          name={index.toString()}
        />
      ))}
    </div>
  );
}
